import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "search"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  placeholder: "请输入要查询的内容",
  class: "inp"
}, null, -1);

export function render(_ctx, _cache) {
  var _component_search = _resolveComponent("search");

  var _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_icon, {
    class: "icon"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_search)];
    }),
    _: 1
  })]);
}